import React from "react";
import styled from "styled-components";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import { TOOL_ACCURACY, TOOL_ACCURACY_TOOLTIP } from "../helpers/accuracy";

const AccuracyTextTooltip = () => {
  /* every instance renders its own <Tooltip>, so the id has to be unique -
     a shared one makes each trigger open all of them at once */
  const tooltipId = `accuracy-text-tooltip-${React.useId()}`;

  return (
    <>
      <AccuracyText
        data-tooltip-id={tooltipId}
        data-tooltip-content={TOOL_ACCURACY_TOOLTIP}
        data-tooltip-place="bottom"
      >
        {TOOL_ACCURACY}
      </AccuracyText>

      <StyledTooltip id={tooltipId} place="bottom" offset={10} />
    </>
  );
};

export default AccuracyTextTooltip;

const AccuracyText = styled.span`
  cursor: pointer;
  text-decoration: underline dotted grey;
`;

const StyledTooltip = styled(Tooltip)`
  max-width: 340px !important;
  background-color: #1f2937 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  padding: 10px 12px !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  z-index: 9999 !important;
  font-weight: 500 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
`;